var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M33.333 8.934v8.326c0 12.695-12.639 17.623-12.639 17.623l-.694.284-.695-.284S6.667 29.955 6.667 17.26V8.933c0-.6.234-1.177.65-1.602a2.2 2.2 0 0 1 1.572-.664H31.11a2.2 2.2 0 0 1 1.571.664 2.3 2.3 0 0 1 .651 1.603"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#service_svg__a)",
  d: "M33.333 17.26V8.933a2.3 2.3 0 0 0-.65-1.602 2.2 2.2 0 0 0-1.572-.664H20.695v28.216c2.108-.716 12.638-4.928 12.638-17.623"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m18.436 21.613 7.411-8.015a1.708 1.708 0 0 1 2.508 2.318l-8.977 9.708c-.508.55-1.376.55-1.884 0l-4.065-4.395a1.708 1.708 0 0 1 2.508-2.319z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "service_svg__a",
  x1: 22.353,
  x2: 22.353,
  y1: -0.458,
  y2: 37.542,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4EDFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#568DFE"
})))));
export default SvgService;